import React from 'react';

import { Button, Result } from 'antd';
import Typography from './Typography';

// Icons
import { Clock } from 'react-feather';
import FeaturedIcon from './FeaturedIcon';

// Styles
import './EmptyState.scss';

interface EmptyStateProps {
  title: React.ReactNode;
  subTitle: React.ReactNode;
  action: React.ReactNode;
  icon: React.ReactNode;
}

// antd
export default function EmptyState({ action, icon, subTitle, title }: EmptyStateProps) {
  return (
    <div className="empty-state">
      <Result
        icon={<FeaturedIcon icon={icon} style={{ margin: 'auto' }} />}
        title={
          <Typography type="text_md" weight="medium">
            {title}
          </Typography>
        }
        subTitle={
          <Typography type="text_sm" style={{ maxWidth: 400, margin: 'auto' }} color="secondary">
            {subTitle}
          </Typography>
        }
        extra={[action]}
      />
    </div>
  );
}
